import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';

import { MeetingDetailsObject } from '@components/meeting-details';
import { APICONFIG } from '@config/api.config';

export const useGetMeetingQuery = (
	id: string | undefined,
	type?: string | undefined
): IQueryResponse<MeetingDetailsObject> => {
	const fetchMeetingListData = async (): Promise<MeetingDetailsObject> => {
		if (!id) {
			throw new Error('Meeting ID is required');
		}
		const baseUrl = type === 'MDP' ? APICONFIG.MDP_MEETINGS_DETAILS : APICONFIG.MEETINGS_DETAILS;
		return APIService.getData<MeetingDetailsObject>(`${baseUrl}/${id}`);
	};

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['MeetingList', id],
		queryFn: fetchMeetingListData,
		refetchOnWindowFocus: false,
		retry: false,
		enabled: !!id,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
		isFetching,
	};
};
